import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import authReducer from 'features/auth/ducks/authReducer';
import clientReducer from 'features/home/ducks/clientReducer';
import actionsReducer from 'features/AuthActions/ducks/actionsReducer';
import clientProfileReducer from 'features/clientProfile/ducks/clientProfileReducer';
import trainerProfileReducer from 'features/trainer/profile/ducks/trainerProfileReducer';
import settingsReducer from 'features/trainer/settings/ducks/settingsReducer';
import timelineReducer from 'features/timeline/ducks/timelineReducer';
import nutritionReducer from 'features/nutrition/ducks/nutritionReducer';
import notesReducer from 'features/clientProfile/components/notesTab/ducks/noteReducer';
import workoutReducer from 'features/work-out/ducks/workoutReducer.js';
import progressReducer from 'features/clientProfile/components/progressTab/ducks/progressReducer';
import goalReducer from 'features/clientProfile/components/Goal/ducks/goalReducer';
import exerciseReducer from 'features/clientProfile/components/Goal/ducks/exerciseReducer';
import assessmentsReducer from 'features/clientProfile/components/assessmentTab/ducks/AssessmentsReducer';
import clientProfileWorkoutReducer from 'features/clientProfile/components/workoutTab/ducks/clientProfileWorkoutReducer';
import overviewReducer from 'features/clientProfile/components/progressTab/program-overview/ducks/OverviewReducer';
import messagesReducer from 'features/messages/components/ducks/messagesReducer.js';
import nutritionLogsReducer from 'features/clientProfile/components/nutritionTab/ducks/nutritionLogsReducer.js';
import questionnaireReducer from 'features/questionnaire/ducks/questionnaireReducer';
import notificationsReducer from 'features/notifications/ducks/notificationsReducer';
import OnboardingQuestionsReducer from 'features/OnboardingQuestions/ducks/OnboardingQuestionsReducer';

const rootReducer = combineReducers({
  routing: routerReducer,
  authReducer,
  clientReducer,
  actionsReducer,
  clientProfileReducer,
  trainerProfileReducer,
  settingsReducer,
  timelineReducer,
  nutritionReducer,
  notesReducer,
  workoutReducer,
  progressReducer,
  goalReducer,
  exerciseReducer,
  assessmentsReducer,
  clientProfileWorkoutReducer,
  overviewReducer,
  messagesReducer,
  nutritionLogsReducer,
  questionnaireReducer,
  notificationsReducer,
  OnboardingQuestionsReducer
});

export default rootReducer;
